// extracted by mini-css-extract-plugin
export var deleteModal = "_ga-0";